// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3855":"d59e8eab","9808":"d59e8eab"}[chunkId] + ".chunk.css";
};